import { CombinedGraphQLErrors } from "@apollo/client/errors";
import { useSupportModeStore } from "@/store/useSupportModeStore";
import type { GraphQLError } from "@/utils/graphqlError";

// Aligned with your backend's ReadableErrorCode enum
const SESSION_EXPIRED_READABLE_CODE = "SESSION_EXPIRED";

let showModal: (() => void) | null = null;
let alreadyShown = false;

function isSessionExpiredError(error: unknown): boolean {
  if (!CombinedGraphQLErrors.is(error)) {
    return false;
  }

  return error.errors.some((graphQLError: GraphQLError) => {
    const readableErrorCode = graphQLError.extensions?.readableErrorCode;

    return readableErrorCode === SESSION_EXPIRED_READABLE_CODE;
  });
}

export function isActiveSupportSessionTimeoutError(error: unknown): boolean {
  if (!isSessionExpiredError(error)) {
    return false;
  }

  return useSupportModeStore.getState().session !== null;
}

export function setupSupportSessionTimeoutNotifier(
  show: () => void
): () => void {
  showModal = show;
  return () => {
    showModal = null;
    alreadyShown = false;
  };
}

export function showSupportSessionTimeoutIfApplicable(error: unknown): boolean {
  if (!isActiveSupportSessionTimeoutError(error)) {
    if (!isSessionExpiredError(error)) {
      return false;
    }

    alreadyShown = false;
    return false;
  }

  if (showModal !== null && !alreadyShown) {
    alreadyShown = true;
    showModal();
  }

  return true;
}
